import React, { useContext } from 'react';
import { View } from 'react-native';
import { Picker } from '@react-native-picker/picker';
import PropTypes from 'prop-types';
import LayoutContext from '../../contexts/Layout';

export const SelectField = React.forwardRef((props, ref) => {
    const { layout } = useContext(LayoutContext);
    const containerStyle = props?.containerStyle;
    const itemStyle = props?.itemStyle;
    const onBlur = props?.onBlur;
    const onValueChange = props?.onValueChange;
    const options = props?.options;
    const style = props?.style;
    const value = props?.value;

    return (
        <View style={containerStyle}>
            <Picker
                itemStyle={itemStyle}
                mode={layout.device.isMobile ? 'dialog' : 'dropdown'}
                onBlur={onBlur}
                onValueChange={onValueChange}
                ref={ref}
                selectedValue={value}
                style={style}
            >
                {options.map(option => (
                    <Picker.Item value={option.value} label={option.label} key={option.label} style={style} />
                ))}
            </Picker>
        </View>
    );
});

SelectField.propTypes = {
    containerStyle: PropTypes.object,
    itemStyle: PropTypes.object,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    onValueChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.any.isRequired
        })
    ).isRequired,
    prompt: PropTypes.string,
    style: PropTypes.object,
    value: PropTypes.any
};
